module.exports = "/_next/static/images/passwords-f2de1f6f0a58f893e0864ddc8020f514.svg";